var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.BallState = {
  INACTIVE:0,
  SET:1,
  READY:2,
  IDLE:3,
  MOVING:4,
  LANDED:5,
}

EHDI.game.MovementState = {
  FIRSTMOVE:0,
  RAMP:1,
  FLY:2,
  DEFLECT:3,
  SUCCESS:4,
  GOBACK_RAMP:5,
  GOBACK_STARTING:6,
  STOP:7,
}

EHDI.game.Ball = function() {
    EHDI.aka.Container2d.call(this);
};

EHDI.game.Ball.prototype = Object.create(EHDI.aka.Container2d.prototype);

EHDI.game.Ball.prototype.init = function () {
  this._state = EHDI.game.BallState.INACTIVE;
  this._sprite;
  this._onPointerDownWithBind;
  this._tl;
  this._deltaDelay = 100;
  this._currentDelta = 0;
  this._topHorLimit = 300;
  this._bottomHorLimit = 280;
  this._horLimitDifference = this._topHorLimit - this._bottomHorLimit;

  this._movementState = EHDI.game.MovementState.FIRSTMOVE;

  this._baseSpeed = 14;
  this._currentSpeed = this._baseSpeed;
  this._texture = [EHDI.Assets.images["disc1a"],
                   EHDI.Assets.images["disc1b"],
                   EHDI.Assets.images["disc2a"],
                   EHDI.Assets.images["disc2b"],
                   EHDI.Assets.images["shadow1"],
                   EHDI.Assets.images["shadow2"]];

  this._tilePos = [new EHDI.aka.Point(-222, -512),
                   new EHDI.aka.Point(0, -512),
                   new EHDI.aka.Point(222, -512),
                   new EHDI.aka.Point(-229, -333),
                   new EHDI.aka.Point(0, -333),
                   new EHDI.aka.Point(229, -333),
                   new EHDI.aka.Point(-239, -158),
                   new EHDI.aka.Point(0, -158),
                   new EHDI.aka.Point(239, -158)];

  this._tilePosLim = [new EHDI.aka.Point(20, 15),
                      new EHDI.aka.Point(21, 15),
                      new EHDI.aka.Point(20, 15),
                      new EHDI.aka.Point(25, 18),
                      new EHDI.aka.Point(28, 18),
                      new EHDI.aka.Point(25, 18),
                      new EHDI.aka.Point(33, 23),
                      new EHDI.aka.Point(32, 23),
                      new EHDI.aka.Point(33, 23)];

  this._speedX = 0;
  this._speedZ = 0;
  this._speedY = 0;
  this._gravity = 0.2;
  this._theta = 0;
  this._horCollisionLimit = this._bottomHorLimit;
  // this._sucessCollision = false;

  this._tileTop;
  this._tileBottom;
  this._tileLeft;
  this._tileRight;
  this._collidedCount;

  if (this._shadow == null) {
    this._shadow = new EHDI.aka.Sprite2d(this._texture[4]);
    this._shadow.anchor.set(0.5,0.5);
    this._shadow.proj.affine = PIXI.projection.AFFINE.AXIS_Y;
    this.addChild(this._shadow);
  }

  if (this._sprite == null) {
    this._sprite = new EHDI.aka.Sprite2d(this._texture[0]);
    this._sprite.anchor.set(0.5,0.5);
    this._sprite.proj.affine = PIXI.projection.AFFINE.AXIS_Y;

    this.addChild(this._sprite);
  }

  this.proj.affine = PIXI.projection.AFFINE.AXIS_X;

  this.interactive = true;
  this.scale.x = 0.9;
  this.scale.y = 0.9;

  if (this._onPointerDownWithBind == null)
    this._onPointerDownWithBind = this._onPointerDown.bind(this);

  this.on('pointerdown', this._onPointerDownWithBind);

}

EHDI.game.Ball.prototype.activate = function () {
  this._setNewState(EHDI.game.BallState.SET);
  this.visible = true;
  this._sprite.y = 0;
  this.x = 370;
  this.y = -20;

  this._tl = TweenLite.to(this, 0.2,{x:0, y:-65, onComplete:this._ballSetComplete.bind(this)});
  EHDI.GAME.soundManager.playSFX("disc");
  // this.y = -450;

  // this._sprite.x = -238;
  // this._sprite.x = -206;
  // this._sprite.y = -524;
  // this._sprite.y = -500;

  // this._sprite.x = -17;
  // this._sprite.x = 17;
  // this._sprite.y = -524;
  // this._sprite.y = -500;

  // this._sprite.x = 238;
  // this._sprite.x = 206;
  // this._sprite.y = -524;
  // this._sprite.y = -500;

  // this._sprite.x = -250;
  // this._sprite.x = -208;
  // this._sprite.y = -352;
  // this._sprite.y = -318;

  // this._sprite.x = -24;
  // this._sprite.x = 24;
  // this._sprite.y = -352;
  // this._sprite.y = -318;

  // this._sprite.x = 250;
  // this._sprite.x = 208;
  // this._sprite.y = -352;
  // this._sprite.y = -318;

  // this._sprite.x = -268;
  // this._sprite.x = -210;
  // this._sprite.y = -178;
  // this._sprite.y = -138;

  // this._sprite.x = -28;
  // this._sprite.x = 28;
  // this._sprite.y = -178;
  // this._sprite.y = -138;

  // this._sprite.x = 268;
  // this._sprite.x = 210;
  // this._sprite.y = -178;
  // this._sprite.y = -138;

  // this.y = -750;
  // console.log(this._sprite.x); 154.6690309551077
  // console.log(this._sprite.y);-159.48631128434596
  // console.log(this.y);-750
}

EHDI.game.Ball.prototype._ballSetComplete = function() {
  if (this._tl != null) {
    this._tl.kill();
    this._tl = null;
  }

  this._tl = TweenLite.to(this._sprite, 0.2,{y:20});

  this._setNewState(EHDI.game.BallState.IDLE);
}

EHDI.game.Ball.prototype._setNewState = function (newState) {
  if (this._state != newState) {
    this._state = newState;
  }

}

EHDI.game.Ball.prototype.getState = function () {
  return this._state;
}

EHDI.game.Ball.prototype._onPointerDown = function() {
  // if (this._state == EHDI.game.BallState.IDLE) {
  //   this._setNewState(EHDI.game.BallState.SET_ANIMATION);
  //   this.emit('BALL_ACTIVATED');
  // //
  // //   this._tl = TweenLite.to(this, 0.2,{y:10, onComplete:this._set.bind(this)});
  // }
}

EHDI.game.Ball.prototype._set = function() {
  this._setNewState(EHDI.game.BallState.SET);
}

EHDI.game.Ball.prototype.shoot = function (angle, barCount) {
  if (this._tl != null) {
    this._tl.kill();
    this._tl = null;
  }

  EHDI.GAME.soundManager.playSFX("disc");
  this._setNewState(EHDI.game.BallState.MOVING);

  // this._currentSpeed = 8;
  this._currentSpeed = 20 * barCount;

  this._speedX = Math.cos(angle) * this._currentSpeed;
  this._speedZ = Math.sin(angle) * this._currentSpeed;
}

EHDI.game.Ball.prototype.update = function(delta) {
  if (this._state == EHDI.game.BallState.MOVING){
    if (this._movementState == EHDI.game.MovementState.FIRSTMOVE) {
      this._updateTexture1(delta);
      this._sprite.x += this._speedX;
      this.y += this._speedZ;

      if (this.y <= -450) {
        this._movementState = EHDI.game.MovementState.RAMP;
        this._speedY = this._speedZ;
        this._speedZ = this._speedZ;
        this._speedX *= 0.8;
      }

      this._checkCollision();
    } else if (this._movementState == EHDI.game.MovementState.RAMP) {
      this._updateTexture2(delta);
      this._sprite.x += this._speedX;
      this._sprite.y += this._speedY;
      this._speedY += this._gravity;

      if (this._sprite.y <= -100) {
        this.emit('SWITCH_BALL');
        this._horCollisionLimit = this._topHorLimit;
        this._movementState = EHDI.game.MovementState.FLY;
      } else if (this._speedY >= 0) {
        // this._speedZ = -this._speedZ + this._speedY;
        this._movementState = EHDI.game.MovementState.GOBACK_RAMP;
        this._horCollisionLimit = this._bottomHorLimit;
      }

      this._checkCollision();
    } else if (this._movementState == EHDI.game.MovementState.GOBACK_RAMP) {
      this._updateTexture2(delta);

      this._sprite.x += this._speedX;
      this._checkCollision();

      if (this._sprite.y < 0) {
        this._sprite.y += this._speedY;
        this._speedY += this._gravity;
      } else if (this._sprite.y >= 0) {
        this._sprite.y = 0;
        this._speedZ = this._speedY;
        this._movementState = EHDI.game.MovementState.GOBACK_STARTING;
      }
    } else if (this._movementState == EHDI.game.MovementState.GOBACK_STARTING) {
      this._updateTexture1(delta);

      this._sprite.x += this._speedX;
      this._checkCollision();

      this.y += this._speedZ;

      if (this.y >= -65) {
        this.y = -65;

        if (this._tl != null) {
          this._tl.kill();
          this._tl = null;
        }

        this._tl = TweenLite.to(this._sprite, 0.2,{y:20});

        this._movementState = EHDI.game.MovementState.FIRSTMOVE;
        this._setNewState(EHDI.game.BallState.IDLE);
        this.emit('BALL_BACK_AT_STARTING');
      }
    } else if (this._movementState == EHDI.game.MovementState.FLY) {
      this._updateTexture2(delta);

      this._speedY += this._gravity;
      this._sprite.y += this._speedY;

      if (this._speedY > -12 && this._checkTileCollision()) {
        this._movementState = EHDI.game.MovementState.SUCCESS;
        this._currentSpeed = Math.sqrt(Math.pow(this._speedX,2) + Math.pow(this._speedY,2));
      } else if (this._sprite.y < -530) {
        this._speedY = -this._speedY;
      } else if (this._sprite.y > -100) {
        this._movementState = EHDI.game.MovementState.GOBACK_RAMP;
        this._horCollisionLimit = this._bottomHorLimit;
      } else if (this._sprite.y > -110) {
        this._horCollisionLimit = this._bottomHorLimit + this._horLimitDifference *  (Math.abs(this._sprite.y + 100)/10);
      }

      this._sprite.x += this._speedX;
      this._checkCollision();
    } else if (this._movementState == EHDI.game.MovementState.SUCCESS) {
      this._updateTexture2(delta);

      this._speedX = this._speedX * 0.9;
      this._speedY = this._speedY * 0.9;

      if (this._sprite.scale.x > 0.9) {
        this._sprite.scale.x -= 0.05 * (this._currentSpeed/20);
        this._sprite.y += this._speedY * (this._currentSpeed/20) * 0.5;

        this._sprite.scale.y = this._sprite.scale.x;
        if (this._sprite.scale.x < 0.9){
          this._sprite.scale.x = 0.9;
          this._sprite.scale.y = 0.9;
        }

        this._shadow.scale.x = this._sprite.scale.x;
        this._shadow.scale.y = this._sprite.scale.x;
      }

      this._sprite.x += this._speedX;
      this._sprite.y += this._speedY;

      if (this._sprite.y < this._tileTop) {
        // this._sucessCollision = true;
        this._sprite.y = this._tileTop;
        this._speedY = -this._speedY;
      } else if (this._sprite.y > this._tileBottom) {
        // this._sucessCollision = true;
        this._sprite.y = this._tileBottom;
        this._speedY = -this._speedY;
      }

      this._checkTileHorCollision();

      if (Math.abs(this._speedY) <= 0.1 && Math.abs(this._speedX) <= 0.1 && this._sprite.scale.x == 0.9) {
        this._setNewState(EHDI.game.BallState.LANDED);
        this._movementState = EHDI.game.MovementState.STOP;
        EHDI.GAME.soundManager.playSFX("gridselect");
        this._animateOut();
      }
    }

    this._shadow.x = this._sprite.x;

    if (this._shadow.texture == this._texture[4]) {
      this._shadow.y = this._sprite.y + 30;
    } else {
      this._shadow.y = this._sprite.y + 20;
    }
  } else if (this._state == EHDI.game.BallState.READY) {
    this._updateTexture3(delta);
  }
}

EHDI.game.Ball.prototype._animateOut = function () {
  this.emit('BALL_ANIMATEOUT', {addScore:true, tileCount:_collidedCount});
  this._tl = TweenLite.to(this, 1,{alpha:0, onComplete:this._animationComplete.bind(this)});
}

EHDI.game.Ball.prototype._animationComplete = function () {
  this.emit('BALL_STOPPED');
}

EHDI.game.Ball.prototype._updateTexture3 = function(delta) {
  this._currentDelta += delta * 0.3;

  if (this._currentDelta >= this._deltaDelay) {
    this._currentDelta -= this._deltaDelay;

    if (this._sprite.texture == this._texture[0]) {
      this._sprite.texture = this._texture[1];
    } else {
      this._sprite.texture = this._texture[0];
    }

    if (this._shadow.texture != this._texture[4]) {
      this._shadow.texture = this._texture[4];
      this._shadow.y = this._sprite.y + 30;
    }

  }
}

EHDI.game.Ball.prototype._updateTexture1 = function(delta) {
  this._currentDelta += delta * this._currentSpeed * 0.07;

  if (this._currentDelta >= this._deltaDelay) {
    this._currentDelta -= this._deltaDelay;

    if (this._sprite.texture == this._texture[0]) {
      this._sprite.texture = this._texture[1];
    } else {
      this._sprite.texture = this._texture[0];
    }

    if (this._shadow.texture != this._texture[4]) {
      this._shadow.texture = this._texture[4];
      this._shadow.y = this._sprite.y + 30;
    }

  }
}

EHDI.game.Ball.prototype._updateTexture2 = function(delta) {
  this._currentDelta += delta * this._currentSpeed * 0.07;

  if (this._currentDelta >= this._deltaDelay) {
    this._currentDelta -= this._deltaDelay;

    if (this._sprite.texture == this._texture[2])
      this._sprite.texture = this._texture[3];
    else
      this._sprite.texture = this._texture[2];

    if (this._shadow.texture != this._texture[5]) {
      this._shadow.texture = this._texture[5];
      this._shadow.y = this._sprite.y + 20;
    }

  }
}

EHDI.game.Ball.prototype._checkTileCollision = function () {
  for (var i = 0; i<9; i++) {
    this._tileTop = this._tilePos[i].y - this._tilePosLim[i].y;
    this._tileBottom = this._tilePos[i].y + this._tilePosLim[i].y;
    this._tileLeft = this._tilePos[i].x - this._tilePosLim[i].x;
    this._tileRight = this._tilePos[i].x + this._tilePosLim[i].x;

    if (this._sprite.x < this._tileRight && this._sprite.x > this._tileLeft && this._sprite.y > this._tileTop && this._sprite.y < this._tileBottom)
    {
      _collidedCount = i;
      return true;
    }
    // if (Math.abs(Math.abs(this._sprite.x) - Math.abs(this._tilePos[i].x)) <= this._tilePosLim[i].x &&
    // Math.abs(Math.abs(this._sprite.y) - Math.abs(this._tilePos[i].y)) <= this._tilePosLim[i].y &&
    // this._sprite.x ) {
    //   this._tileTop = this._tilePos[i].y - this._tilePosLim[i].y;
    //   this._tileBottom = this._tilePos[i].y + this._tilePosLim[i].y;
    //   this._tileLeft = this._tilePos[i].x - this._tilePosLim[i].x;
    //   this._tileRight = this._tilePos[i].x + this._tilePosLim[i].x;
    //   console.log(i);
    //   console.log(this._tileTop);
    //   console.log(this._tileBottom);
    //   console.log(this._tileLeft);
    //   console.log(this._tileRight);
    //
    //   return true;
    // }
  }

  return false;
}

EHDI.game.Ball.prototype._checkTileHorCollision = function() {
  if (this._sprite.x < this._tileLeft) {
    // this._sucessCollision = true;
    this._sprite.x = this._tileLeft;
    // this._theta = Math.abs(this._theta - (Math.PI/2));
    this._speedX = -this._speedX ;
    EHDI.GAME.soundManager.playSFX("disc");
    // this._speedZ = Math.sin(this._theta) * -this._currentSpeed;
  } else if (this._sprite.x > this._tileRight) {
    // this._sucessCollision = true;
    this._sprite.x = this._tileRight;
    // this._theta = Math.abs(this._theta - (Math.PI/2));
    this._speedX = -this._speedX ;
    EHDI.GAME.soundManager.playSFX("disc");
    // this._speedZ = Math.sin(this._theta) * -this._currentSpeed;
  }
}

EHDI.game.Ball.prototype._checkCollision  = function() {
// console.log(this._sprite.x + " [ ] " + this._horCollisionLimit);


  if (this._sprite.x < -this._horCollisionLimit) {
    this._sprite.x = - this._horCollisionLimit;
    // this._theta = Math.abs(this._theta - (Math.PI/2));
    this._speedX = -this._speedX ;
    EHDI.GAME.soundManager.playSFX("disc");
    // this._speedZ = Math.sin(this._theta) * -this._currentSpeed;
  } else if (this._sprite.x > this._horCollisionLimit) {
    this._sprite.x = this._horCollisionLimit;
    // this._theta = Math.abs(this._theta - (Math.PI/2));
    this._speedX = -this._speedX ;
    EHDI.GAME.soundManager.playSFX("disc");
    // this._speedZ = Math.sin(this._theta) * -this._currentSpeed;
  }
}

EHDI.game.Ball.prototype.reset = function () {
  this._state = EHDI.game.BallState.INACTIVE;
  this._currentDelta = 0;
  this._movementState = EHDI.game.MovementState.FIRSTMOVE;
  this._currentSpeed = this._baseSpeed;

  this._speedX = 0;
  this._speedZ = 0;
  this._speedY = 0;
  this._theta = 0;
  this._horCollisionLimit = this._bottomHorLimit;
  // this._sucessCollision = false;

  this._tileTop = null;
  this._tileBottom = null;
  this._tileLeft = null;
  this._tileRight = null;
  this._collidedCount = null;

  this._shadow.texture = this._texture[4];
  this._sprite.texture = this._texture[0];

  this.visible = true;
  this.alpha = 1;

  this._sprite.x = 0;
  this._sprite.y = 0;
  this._shadow.x = 0;
  this._shadow.y = 30;
  this.y = 0;
}

EHDI.game.Ball.prototype.setZ = function (z) {
  this.y = z;
}

EHDI.game.Ball.prototype.setX = function (x) {
  this._sprite.x = x;
  this._shadow.x = x;
}

EHDI.game.Ball.prototype.setY = function (y) {
  this._sprite.y = y;
}

EHDI.game.Ball.prototype.getZ = function () {
  return this.y;
}

EHDI.game.Ball.prototype.getX = function () {
  return this._sprite.x;
}

EHDI.game.Ball.prototype.getY = function () {
  return this._sprite.y;
}

EHDI.game.Ball.prototype.pause = function () {
  if (this._tl != null) {
    this._tl.pause();
  }
}

EHDI.game.Ball.prototype.resume = function () {
  if (this._tl != null) {
    this._tl.resume();
  }
}

EHDI.game.Ball.prototype.ready = function () {
  this._setNewState(EHDI.game.BallState.READY);

  if (this._tl != null) {
    this._tl.kill();
    this._tl = null;
  }

  this._tl = TweenLite.to(this._sprite, 0.2,{y:0});
}

EHDI.game.Ball.prototype.set = function () {
  this._setNewState(EHDI.game.BallState.IDLE);

  if (this._tl != null) {
    this._tl.kill();
    this._tl = null;
  }

  this._tl = TweenLite.to(this._sprite, 0.2,{y:20});
}
